import {formInputs} from "../form/inputs";

export const commonCalculatorComponent = ($r, $formGroups) => {
    const {
        inputs,
        setError,
        clearError,
    } = formInputs($r, $formGroups);

    const parseValue = value => parseFloat(value.replace(',', '.').replace(' ', ''));
    const formatValue = value => value.toFixed(Math.floor(value) !== value ? 2 : 0);

    const validate = (key, setError = () => {}) => {
        const value = inputs[key].value;
        if (!value.length) {
            setError(key, 'Hodnota je povinná');
            return false;
        }

        const numericValue = parseValue(value);
        if (isNaN(numericValue)) {
            setError(key, 'Hodnota musí byť číslo');
            return false;
        }

        clearError(key);
        return true;
    };

    const isValid = key => validate(key);

    return {
        inputs,
        parseValue,
        formatValue,
        setError,
        clearError,
        validate,
        isValid,
    };
};
